import React from 'react';
import { Search } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface MobileSearchButtonProps {
  onClick: () => void;
}

export function MobileSearchButton({ onClick }: MobileSearchButtonProps) {
  return (
    <Button 
      variant="ghost" 
      size="sm" 
      onClick={onClick}
      className="h-9 w-9 sm:hidden"
    >
      <Search className="h-5 w-5" />
    </Button>
  );
}